// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__ycbtL","icon":"tooltip_icon__0bCM8","container":"tooltip_container__zDKiB","title":"tooltip_title__peRcs","text":"tooltip_text__w5Zj7"};